import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { an } from '@fullcalendar/core/internal-common';
import { ToastrService } from 'ngx-toastr';
import { getLongDate, PaginationUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { Destination } from 'src/app/models/destination.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AssociationPlaceDestinationService } from 'src/app/services/association-place-destination.service';
import { DestinationService } from 'src/app/services/destination.service';
import { MayeReportService } from 'src/app/services/maye-report.service';
import { PlaceService } from 'src/app/services/place.service';
import { ProductService } from 'src/app/services/product.service';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { InventoryReportService } from 'src/app/services/reports/inventory-report.service';

@Component({
  selector: 'app-maye-reports',
  templateUrl: './maye-reports.component.html',
  styleUrls: ['./maye-reports.component.scss']
})
export class MayeReportsComponent {
  isOpen = true;
  btnExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnPdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  btnJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  lastDownloadDate: Date | null = null;
  ordersSaleData: any = null;

  isSalesBookOpen = false;

  startDateSales: string | null = null;
  endDateSales: string | null = null;

  btnSalesExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnSalesPdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  btnSalesJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  salesBookData: any = null;

  destinations: any[] = [];
  filterDestination: Destination[] = [];
  destinationFilter: Destination[] = [];
  destinationFilterBalance: any[] = [];
  destinationFilterMargin: any[] = [];

  isUtilityOpen = false;

  startDateUtility: string | null = null;
  endDateUtility: string | null = null;

  btnUtilityExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnUtilityPdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  btnUtilityJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  utilityReportData: any = null;

  products: any[] = [];
  productFilter: any[] = [];
  productSelected: any = null;
  timeout: any;

  isPlaceExistenceOpen = false;

  endDatePlaceExistence: string | null = null;

  btnPlaceExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnPlacePdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  btnPlaceJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  existencesPlaceData: any = null;

  places: any[] = [];
  filterPlaces: any[] = [];
  filterPlacesMargin: any[] = [];

  isBalacenPlaceOpen = false;

  startDateBalacenPlace: string | null = null;
  endDateBalacenPlace: string | null = null;

  btnBalacenPlaceExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnBalacenPlaceJson = new ButtonLoading("btn-primary", false, "", "fa fa-eye");

  isResultPlaceOpen = false;

  startDateResultPlace: string | null = null;
  endDateResultPlace: string | null = null;

  btnResultPlaceExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnResultPlacePdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  btnResultPlaceJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  resultPlaceData: any = null;

  isClientDestinationBalanceOpen = false;

  startDateClientDestination: string | null = null;
  endDateClientDestination: string | null = null;

  btnClientDestinationExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnClientDestinationPdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  btnClientDestinationJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  clientDestinationData: any = null;
  paginationClientDestination = new PaginationModel(0, 5, 0, 0, [], []);

  balancePlacePreview: any = null;
  loadingBalancePlacePreview = false;

  placeInventoryPreview: any[] | null = null;
  loadingPlaceInventoryPreview = false;
  associatedDestinations: any[] = [];


  isGeneralTable = false;

  startDateGeneralTable: string | null = null;
  endDateGeneralTable: string | null = null;

  btnExcelGeneralTable = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnJsonGeneralTable = new ButtonLoading("btn-info", false, "", "fa fa-eye");
  generalTableReportData: any = null;
  loadingGeneralTable = false;

  isAdministrativeInvoicesOpen = false;
  startDateAdministrativeInvoices: string | null = null;
  endDateAdministrativeInvoices: string | null = null;

  btnAdministrativeInvoicesExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnAdministrativeInvoicesJson = new ButtonLoading("btn-info", false, "", "fa fa-eye");

  administrativeInvoicesData: any = null;

  inputs: any = {
    destination: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: { id: null }
    },
    productKardex: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: '',
      color: '',
      tooltip: 'status-warehouse',
      data: { id: null }
    },

    utilityDestination: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: { id: null }
    },
    place: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: { id: null }
    },
    placeMargin: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: { id: null }
    }
  };

  inputsDestination = {
    destination: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    },
    destinationBalance: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    },
    destinationMargin: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    }
  };

  constructor(
    private mayeReportService: MayeReportService,
    private accountingReport: AccountingReportService,
    private destinationService: DestinationService,
    private inventoryReport: InventoryReportService,
    private productService: ProductService,
    private placeService: PlaceService,
    private associationService: AssociationPlaceDestinationService,
    private toast: ToastrService
  ) {
    const today = new Date().toLocaleDateString('en-CA');;
    this.startDateSales = today;
    this.endDateSales = today;

    this.startDateUtility = today;
    this.endDateUtility = today;

    this.startDateBalacenPlace = today;
    this.endDateBalacenPlace = today;

    this.startDateResultPlace = today;
    this.endDateResultPlace = today;

    this.startDateClientDestination = today;
    this.endDateClientDestination = today;

    this.endDatePlaceExistence = today;

    this.startDateGeneralTable = today;
    this.endDateGeneralTable = today;
    this.startDateAdministrativeInvoices = today;
    this.endDateAdministrativeInvoices = today;

  }

  ngOnInit(): void {
    this.getDestinations();
    this.getProducts('');
    this.getPlaces();
  }

  toggleSection() {
    this.isOpen = !this.isOpen;
  }

  downloadReport(type: string) {
    const button = type === 'excel' ? this.btnExcel : this.btnPdf;
    if (button.loading) return;
    button.loading = true;

    this.mayeReportService.getOrdersReserved(type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, 'Pedidos de Venta Reservados');
        this.toast.success('Reporte descargado correctamente');
        this.lastDownloadDate = new Date();
        button.loading = false;
      },
      error: () => {
        this.toast.error('Error al descargar el reporte');
        button.loading = false;
      }
    });
  }

  downloadReportJson() {
    const button = this.btnJson;
    if (button.loading) return;
    button.loading = true;

    this.mayeReportService.getOrdersReserved("json").subscribe({
      next: (response: ResponseObject) => {
        this.ordersSaleData = response.data;
        this.lastDownloadDate = new Date();
        button.loading = false;
        console.log(response.data);

      },
      error: () => {
        this.toast.error('Error al descargar el reporte');
        button.loading = false;
      }
    });
  }

  toggleSalesBook() {
    this.isSalesBookOpen = !this.isSalesBookOpen;
  }

  downloadSalesBook(type: 'excel' | 'pdf' | 'json') {
    const button = type === 'excel' ? this.btnSalesExcel : (type === 'pdf' ? this.btnSalesPdf : this.btnSalesJson);
    if (button.loading) return;

    if (!this.startDateSales || !this.endDateSales) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    const selectedDestinations = this.destinations.filter(d => d.selected);
    const selectedIds = selectedDestinations.map(d => d.id);
    const data = {destinations: selectedIds};

    button.loading = true;

    this.accountingReport
      .getSalesBookByMultiDestination(getLongDate(this.startDateSales), getLongDate(this.endDateSales), type, data)
      .subscribe({
        next: (response: ResponseObject) => {
          if (type === "json") {
            this.salesBookData = response.data;
            console.log(this.salesBookData);

            this.lastDownloadDate = new Date();
            button.loading = false;
            return;
          }
          this.downloadFile(response.data, type, 'Libro de Ventas');
          this.toast.success('Libro de Ventas descargado correctamente');
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el Libro de Ventas');
          button.loading = false;
        }
      });
  }

  private downloadFile(base64: string, type: string, filename: string) {
    const fileBytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
    const blob = new Blob([fileBytes], {
      type: type === 'pdf'
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.${type === 'pdf' ? 'pdf' : 'xlsx'}`;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  changeInput(input: any, value: any, verified: any, required: any, classIcon: any, data: any) {
    input.value = (value !== undefined && value !== null) ? value : input.value;
    input.verified = (verified !== undefined && verified !== null) ? verified : input.verified;
    input.required = (required !== undefined && required !== null) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data !== undefined && data !== null) ? data : input.data;
  }

  getDestinations() {
    this.destinationService.getDestinationsActive(true).subscribe({
      next: (response: ResponseObject) => {
        this.destinations = response.data;
        this.filterDestination = this.destinations;
        this.destinationFilter = this.destinations;
        this.destinationFilterMargin = this.destinations;
        this.destinationFilterBalance = this.destinations;
      },
      error: () => this.toast.error("Error al obtener destinos", "Error")
    });
  }

  writeDestination(input: any) {
    const inputValue = input.target.value;

    this.filterDestination = this.destinations.filter((d) =>
      (d.name || '').toLowerCase().includes((inputValue || '').toLowerCase())
    );

    if (this.filterDestination.length === 0) {
      this.changeInput(this.inputs.destination, null, false, null, 'fa-xmark', null);
    } else if (this.filterDestination.length === 1) {
      this.changeInput(this.inputs.destination, this.filterDestination[0].name, true, null, 'fa-circle-check', this.filterDestination[0]);
    } else {
      this.changeInput(this.inputs.destination, inputValue, false, null, 'fa-list', null);
    }
  }

  checkDestination(destination: Destination) {
    this.inputs.destination.class = "fa-circle-check";
    this.inputs.destination.verified = true;
    this.inputs.destination.data = destination;
    this.inputs.destination.value = destination.name;
  }


  writeUtilityDestination(input: any) {
    const inputValue = input.target.value || '';

    this.filterDestination = this.destinations.filter((d) =>
      (d.name || '').toLowerCase().includes(inputValue.toLowerCase())
    );

    if (this.filterDestination.length === 0) {
      this.changeInput(this.inputs.utilityDestination, null, false, null, 'fa-xmark', null);
    } else if (this.filterDestination.length === 1) {
      this.changeInput(this.inputs.utilityDestination, this.filterDestination[0].name, true, null, 'fa-circle-check', this.filterDestination[0]);
    } else {
      this.changeInput(this.inputs.utilityDestination, inputValue, false, null, 'fa-list', null);
    }
  }

  checkUtilityDestination(destination: Destination) {
    this.inputs.utilityDestination.class = "fa-circle-check";
    this.inputs.utilityDestination.verified = true;
    this.inputs.utilityDestination.data = destination;
    this.inputs.utilityDestination.value = destination.name;
  }

  getProducts(input: string) {
    this.productService.getProducts(input).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.productFilter = this.products;
      },
      error: () => this.toast.error("Error al obtener los productos")
    });
  }

  writeProductKardex(event: any) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value || '';

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const lowercase = inputValue.toLowerCase();
      this.productFilter = this.products.filter((product) => {
        return (product.id + " " + product.name).toLowerCase().includes(lowercase)
          || product.code?.toLowerCase().includes(lowercase)
          || product.barCode?.toLowerCase().includes(lowercase);
      });

      if (this.productFilter.length === 1) {
        this.selectProduct(this.productFilter[0]);
      } else {
        this.inputs.productKardex.class = this.inputs.productKardex.required ? "fa-asterisk" : "";
        this.inputs.productKardex.verified = false;
        this.productSelected = null;
      }
    }, 500);
  }

  selectProduct(product: any) {
    clearTimeout(this.timeout);
    this.inputs.productKardex.class = "fa-circle-check";
    this.inputs.productKardex.verified = true;
    this.inputs.productKardex.value = product.name;
    this.productSelected = product;
  }

  getProfitMarginReport(type: 'excel' | 'pdf' | 'json') {
    const button = type === 'excel' ? this.btnUtilityExcel : type === 'pdf' ? this.btnUtilityPdf : this.btnUtilityJson;
    if (button.loading) return;

    if (!this.startDateUtility || !this.endDateUtility) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    const placeId =
      this.inputs.place.verified && this.inputs.place.data?.id
        ? this.inputs.place.data.id
        : null;

    if (!placeId) {
      this.toast.warning('Selecciona una ubicación (place) válida');
      return;
    }

    if (type === 'json') {
      this.loadingPlaceInventoryPreview = true;
      this.placeInventoryPreview = null;
    }
    
    const selectedDestinations = this.destinationFilterMargin.filter(d => d.selected);
    const selectedIds = selectedDestinations.map(d => d.id);
    const data = {destinations: selectedIds, place: placeId};

    const productId = this.productSelected ? this.productSelected.id : null;

    button.loading = true;

    this.inventoryReport
      .getProfitMarginReportByMultiDestination(
        getLongDate(this.startDateUtility),
        getLongDate(this.endDateUtility),
        productId,
        data,
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          if (type === 'json') {
            this.utilityReportData = response.data;
            button.loading = false;
            return;
          }
          this.downloadFile(response.data, type, `Margen de Utilidad y Reportería Por Destino ${this.endDateUtility}`);
          this.toast.success('Se ha descargado el reporte de Margen de Utilidad y Reportería Por Destino');
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte de Margen de Utilidad y Reportería Por Destino');
          button.loading = false;
        }
      });
  }

  getBalancePlaceReport(type: 'excel' | 'json') {
    const button = type === 'excel' ? this.btnBalacenPlaceExcel : this.btnBalacenPlaceJson;
    if (button.loading) return;

    if (!this.startDateBalacenPlace || !this.endDateBalacenPlace) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    button.loading = true;

    this.mayeReportService
      .getBalanceByPlaceForDestination(
        this.startDateBalacenPlace.toString().split('T')[0],
        this.endDateBalacenPlace.toString().split('T')[0],
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          if (type === 'json') {
            this.showJsonPreview(response.data);
            this.loadingBalancePlacePreview = false;
          } else {
            this.downloadFile(response.data, type, `Saldos por Ubicación y Destino ${this.endDateBalacenPlace}`);
            this.toast.success('Se ha descargado el reporte de Saldos por Ubicación y Destino');
          }
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte de Saldos por Ubicación y Destino');
          button.loading = false;
        }
      });
  }

  getResultPlaceReportJson(type: 'json') {
    const button = this.btnResultPlaceJson;
    if (button.loading) return;

    if (!this.startDateResultPlace || !this.endDateResultPlace) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    button.loading = true;

    this.mayeReportService
      .getResultByPlaceForDestination(
        this.startDateResultPlace.toString().split('T')[0],
        this.endDateResultPlace.toString().split('T')[0],
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          this.resultPlaceData = response.data;
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte de Resultados por Ubicación y Destino');
          button.loading = false;
        }
      });
  }

  getResultPlaceReport(type: 'excel' | 'pdf') {
    const button = type === 'excel' ? this.btnResultPlaceExcel : this.btnResultPlacePdf;
    if (button.loading) return;

    if (!this.startDateResultPlace || !this.endDateResultPlace) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    button.loading = true;

    this.mayeReportService
      .getResultByPlaceForDestination(
        this.startDateResultPlace.toString().split('T')[0],
        this.endDateResultPlace.toString().split('T')[0],
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          this.downloadFile(response.data, type, `Resultados por Ubicación y Destino ${this.endDateResultPlace}`);
          this.toast.success('Se ha descargado el reporte de Resultados por Ubicación y Destino');
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte de Resultados por Ubicación y Destino');
          button.loading = false;
        }
      });
  }

  toggleUtilityReport() {
    this.isUtilityOpen = !this.isUtilityOpen;
  }

  toggleBalacenPlaceReport() {
    this.isBalacenPlaceOpen = !this.isBalacenPlaceOpen;
  }

  toggleResultPlaceReport() {
    this.isResultPlaceOpen = !this.isResultPlaceOpen;
  }

  getPlaces() {
    this.placeService.getActivePlaces().subscribe({
      next: (response: any) => {
        this.places = response.data;
        this.filterPlaces = this.places;
        this.filterPlacesMargin = this.places;
      },
      error: () => this.toast.error("Error al obtener ubicaciones (places)")
    });
  }

  togglePlaceExistence() {
    this.isPlaceExistenceOpen = !this.isPlaceExistenceOpen;
  }

  writePlace(input: any) {
    const inputValue = (input.target.value || '').toLowerCase();

    this.filterPlaces = this.places.filter((p) =>
      (p.name || '').toLowerCase().includes(inputValue)
    );

    if (this.filterPlaces.length === 0) {
      this.changeInput(this.inputs.place, null, false, null, 'fa-xmark', null);
    } else if (this.filterPlaces.length === 1) {
      this.changeInput(this.inputs.place, this.filterPlaces[0].name, true, null, 'fa-circle-check', this.filterPlaces[0]);
    } else {
      this.changeInput(this.inputs.place, input.target.value, false, null, 'fa-list', null);
    }


  }

  checkPlace(place: any) {
    if(this.inputs.place.verified && place.id==this.inputs.place.data.id) {
      this.inputs.place.class = "fa-list";
      this.inputs.place.verified = false;
      this.inputs.place.data = null;
      this.inputs.place.value = null;
    } else {
      this.inputs.place.class = "fa-circle-check";
      this.inputs.place.verified = true;
      this.inputs.place.data = place;
      this.inputs.place.value = place.name;
    }
    
    if(this.inputs.place.data) {
      this.selectPlace(this.inputs.place.data.id);
    } else {
      this.destinationFilterMargin = this.destinations;
    }
  }

  selectPlace(placeId: number) {
    if (!this.inputs.place.verified) return;

    this.associationService.getAssociationsByPlace(placeId).subscribe({
      next: (resp: ResponseObject) => {
        const associations = resp.data || [];
        this.associatedDestinations = associations;
        this.destinationFilterMargin = this.destinations.filter(d =>
          associations.some(a => a.destinationId === d.id)
        );
        
      },
      error: (error) => {
        console.error(error);
        this.toast.error('Error al obtener asociaciones de la ubicación');
      }
    });
  }

  downloadExistenceByPlace(type: 'excel' | 'json') {
    const button = type === 'excel' ? this.btnPlaceExcel : this.btnPlaceJson;
    if (button.loading) return;

    const placeId =
      this.inputs.place.verified && this.inputs.place.data?.id
        ? this.inputs.place.data.id
        : null;

    if (!placeId) {
      this.toast.warning('Selecciona una ubicación (place) válida');
      return;
    }

    if (type === 'json') {
      this.loadingPlaceInventoryPreview = true;
      this.placeInventoryPreview = null;
    }

    button.loading = true;

    this.mayeReportService.getExistenceByPlace(placeId, type, this.endDatePlaceExistence.toString().split('T')[0]).subscribe({
      next: (response: ResponseObject) => {
        if (type === 'json') {
          this.existencesPlaceData = response.data;
          // this.showPlaceInventoryPreview(response.data);
          // this.loadingPlaceInventoryPreview = false;
        } else {
          this.downloadFile(response.data, type, `Existencia por Ubicación ${this.inputs.place.value}`);
          this.toast.success('Reporte descargado correctamente');
        }
        button.loading = false;
      },
      error: () => {
        this.toast.error('Error al descargar el reporte');
        button.loading = false;
      }
    });
  }

  getClientDestinationBalanceReport(type: 'excel' | 'pdf' | 'json') {
    const button =
      type === 'excel'
        ? this.btnClientDestinationExcel
        : type === 'pdf'
          ? this.btnClientDestinationPdf
          : this.btnClientDestinationJson;

    if (button.loading) return;

    if (!this.startDateClientDestination || !this.endDateClientDestination) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    const selectedDestinations = this.destinationFilterBalance.filter(d => d.selected);
    const selectedIds = selectedDestinations.map(d => d.id);
    const data = {destinationIds: selectedIds};

    if (!selectedIds || selectedIds.length === 0) {
      this.toast.warning('Selecciona un destino válido');
      return;
    }

    button.loading = true;

    this.mayeReportService
      .getClientMultiDestinationBalance(
        data,
        this.startDateClientDestination,
        this.endDateClientDestination,
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          if (type === 'json') {
            this.clientDestinationData = response.data;
            // this.paginationClientDestination = PaginationUtil.initializePagination(
            //   response.data.length,
            //   this.paginationClientDestination.pageSize
            // );
            // this.paginationClientDestination.total = response.data;
            // this.resetPagination(this.paginationClientDestination);
            button.loading = false;
            return;
          }     
          this.downloadFile(
            response.data,
            type,
            `Saldos Clientes por Destino ${this.inputs.destination.value}`
          );
          this.toast.success('Reporte descargado correctamente');
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte');
          button.loading = false;
        }
      });
  }

  resetPagination(paginationTemp) {
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }
  showJsonPreview(data: any) {
    this.balancePlacePreview = data;
  }

  showPlaceInventoryPreview(data: any) {
    this.placeInventoryPreview = (data ?? []) as any[];
  }

  handleInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'destination') {
      clearTimeout(this.timeout);
      this.inputsDestination.destination.class = "typing";
      this.timeout = setTimeout(() => {
        this.destinationFilter = this.destinations.filter((destination) =>
          destination.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          destination.id == parseInt(inputValue)
        );
        if (this.destinationFilter.length === 0) {
          this.changeStatusInput(null, null, 0, 'destination');
        } else {
          this.inputsDestination.destination.class = "bx bx-list-check";
        }
      }, 500);
    }
  }

  verifiedInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'destination') {
      let temp: any = this.destinations.filter((destination) =>
        destination.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        destination.id == parseInt(inputValue)
      );
      if (temp.length === 1) {
        this.changeStatusInput(temp[0], (temp[0].barCode ? temp[0].barCode + ' - ' : '') + temp[0].name, 1, 'destination');
      } else {
        this.changeStatusInput(null, null, 0, 'destination');
      }
    }
  }


  changeStatusInput(selected: any, newValue: string, status: number, type: string) {
    let tempInput = this.inputsDestination[type];
    tempInput.verified = status === 1;
    if (status === 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = 'fa-check';
    } else {
      tempInput.data = null;
      tempInput.color = 'danger';
      tempInput.class = (status === 0) ? 'fa-xmark' : 'fa-asterisk';
    }
  }


  toggleGeneralTable() {
    this.isGeneralTable = !this.isGeneralTable;
  }

  getGeneralTable(type: 'excel' | 'json') {
    const button = type === 'excel' ? this.btnExcelGeneralTable : this.btnJsonGeneralTable;
    if (button.loading) return;

    if (!this.startDateGeneralTable || !this.endDateGeneralTable) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }


    if (type === 'json') {
      this.loadingGeneralTable = true;
    }

    button.loading = true;

    this.inventoryReport
      .getGeneralTable(
        this.startDateGeneralTable,
        this.endDateGeneralTable,
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          if (type === 'json') {
            this.generalTableReportData = response.data;
            button.loading = false;
            return;
          }
          this.downloadFile(response.data, type, `Reporte Tabla General ${this.endDateUtility}`);
          this.toast.success('Se ha descargado el reporte Tabla General');
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte Tabla General');
          button.loading = false;
        }
      });
  }

  toggleAdministrativeInvoices() {
    this.isAdministrativeInvoicesOpen = !this.isAdministrativeInvoicesOpen;
  }

  downloadAdministrativeInvoices(type: 'excel' | 'json') {
    const button = type === 'excel'
      ? this.btnAdministrativeInvoicesExcel
      : this.btnAdministrativeInvoicesJson;

    if (button.loading) return;

    if (!this.startDateAdministrativeInvoices || !this.endDateAdministrativeInvoices) {
      this.toast.warning('Selecciona fecha inicial y final');
      return;
    }

    button.loading = true;

    this.mayeReportService
      .getAdministrativeInvoices(
        this.startDateAdministrativeInvoices,
        this.endDateAdministrativeInvoices,
        type
      )
      .subscribe({
        next: (response: ResponseObject) => {
          if (type === 'json') {
            this.administrativeInvoicesData = response.data;
            button.loading = false;
            return;
          }

          this.downloadFile(
            response.data,
            'excel',
            `Facturas Administrativas ${this.endDateAdministrativeInvoices}`
          );
          this.toast.success('Reporte descargado correctamente');
          button.loading = false;
        },
        error: () => {
          this.toast.error('Error al descargar el reporte');
          button.loading = false;
        }
      });
  }
}
